<template>
    <div v-if="!isLoading" id="Inforequest" class="box-inforequest landing">
        <div class="app-width" v-if="!isSuccess">
            <div class="content">
                <div v-if="titleForm" class="main-title mrg">{{ titleForm }}</div>
                <div class="form">
                    <fieldset :disabled="isLoadingForm" class="fieldset">
                        <div class="item">
                            <label class="label" for="NameSurname">{{ localizer.get("LandingPage.InfoRequest.NameSurname") }}</label>
                            <div class="control">
                                <input type="text" id="NameSurname" v-model.lazy="formData.nameSurname" :class="[{ 'input-validation-error': isValidationError('NameSurname') }, 'textbox']" />
                            </div>
                        </div>
                        <div class="item">
                            <label class="label" for="Phone">{{ localizer.get("LandingPage.InfoRequest.Phone") }}</label>
                            <div class="control">
                                <input type="tel" id="Phone" v-model.lazy="formData.phone" :placeholder="localizer.get('LandingPage.InfoRequest.PhonePlaceholder')" :class="[{ 'input-validation-error': isValidationError('Phone') }, 'textbox']" />
                            </div>
                        </div>
                        <div class="item">
                            <label class="label" for="Email">{{ localizer.get("LandingPage.InfoRequest.Email") }}</label>
                            <div class="control">
                                <input type="email" id="Email" v-model.lazy="formData.email" :placeholder="localizer.get('LandingPage.InfoRequest.EmailPlaceholder')" :class="[{ 'input-validation-error': isValidationError('Email') }, 'textbox']" />
                            </div>
                        </div>
                        <div class="item">
                            <label class="label" for="Country">{{ localizer.get("LandingPage.InfoRequest.Country") }}</label>
                            <div class="control">
                                <select id="Country" v-model.lazy="formData.country" :class="[{ 'input-validation-error': isValidationError('Country') }, 'dropdown']">
                                    <option :value="null">...</option>
                                    <option v-for="(country, index) in countries" :value="country.value" :key="index">
                                        {{ country.title }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="item" v-if="formData.country === 'IT'">
                            <label class="label" for="Zone">{{ localizer.get("LandingPage.InfoRequest.Zones") }}</label>
                            <div class="control">
                                <select id="Zone" v-model.lazy="formData.zone" :class="[{ 'input-validation-error': isValidationError('Zone') }, 'dropdown']">
                                    <option :value="null">...</option>
                                    <option v-for="(zone, index) in zones" :value="zone.value" :key="index">
                                        {{ zone.title }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="item" data-lable="top">
                            <label class="label" for="">{{ localizer.get("LandingPage.InfoRequest.Message") }}</label>
                            <div class="control">
                                <textarea cols="15" type="text" id="Message" maxlength="500" v-model.lazy="formData.message" rows="3" :class="[{ 'input-validation-error': isValidationError('Message') }, 'textarea']" />
                            </div>
                        </div>
                    </fieldset>
                    <fieldset :disabled="isLoadingForm" class="fieldset">
                        <div class="item">
                            <div class="checkbox">
                                <input type="checkbox" id="isPrivacyPolicy" v-model="formData.isPrivacyPolicy" />
                                <label for="isPrivacyPolicy" v-html="localizer.get('LandingPage.InfoRequest.PrivacyPolicy', routes.Terms_PrivacyPolicy)"></label>
                            </div>
                        </div>
                    </fieldset>
                    <fieldset :disabled="isLoadingForm" class="fieldset">
                        <div class="item">
                            <div class="g-recaptcha" :data-sitekey="recaptchaSiteKey"></div>
                        </div>
                    </fieldset>
                    <fieldset :disabled="isLoadingForm" class="fieldset">
                        <div v-if="validationErrors.length !== 0" class="validation-summary-errors">
                            <ul>
                                <li v-for="(validationError, index) in validationErrors" :key="index">{{ validationError.message }}</li>
                            </ul>
                        </div>
                        <div class="item">
                            <div class="cta">
                                <button v-if="!isLoading" class="button" data-width="300" @click="submitForm()">{{ localizer.get("LandingPage.InfoRequest.SendRequest") }}</button>
                                <div v-else class="button" data-width="300" data-disabled>
                                    <div class="loader-box" data-type="button">
                                        <div class="loader"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </div>
            </div>
            <img src="/images/box-inforequest.png" width="462" height="721" alt="Mecmedix" class="image">
        </div>
        <div v-else class="app-width success">
            <div class="content">
                <div class="main-title" data-mrgb="30">{{ localizer.get("LandingPage.InfoRequest.FormSuccessTitle") }}</div>
                <div class="main-abstract">{{ localizer.get("LandingPage.InfoRequest.FormSuccessDescription") }}</div>
            </div>
            <img src="/images/box-inforequest.png" width="462" height="721" alt="Mecmedix" class="image">
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, computed, onBeforeMount } from "vue";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";
import FormHelper from "@Scripts/Common/FormHelper";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

const props = defineProps<{
    recaptchaSiteKey: string,
    titleForm: string,
    landingPageSlug: string
}>();

const localizer = Localizer;

const isLoading = ref<boolean>(true);
const isLoadingForm = ref<boolean>(false);
const isSuccess = ref<boolean>(false);
const formData = ref<any>({ country: null, zone: null, isPrivacyPolicy: false });
const countries = ref<any[]>([]);
const zones = ref<any[]>([]);
const validationErrors = ref<any[]>([]);
const routes = (window as any).App.routes;

onBeforeMount(async () => {
    await getData();
    setRecaptcha();
});

function setRecaptcha() {
    let recaptchaScript = document.createElement("script");
    recaptchaScript.setAttribute("src", "https://www.recaptcha.net/recaptcha/api.js");
    document.head.appendChild(recaptchaScript);
}

async function getData() {
    const response = (await Axios.post(routes.LandingPage_LandingPage_GetSubscribeData)).data;

    countries.value = response.countries;
    zones.value = response.zones;

    isLoading.value = false;
}

async function submitForm() {
    FormHelper.removeFocus();
    validationErrors.value = [];
    isLoadingForm.value = true;

    formData.value.landingPageSlug = props.landingPageSlug;

    try {
        await Axios.post(routes.LandingPage_LandingPage_Submit, formData.value, { headers: { "RecaptchaVerificationToken": (<any>window).grecaptcha.getResponse() } });

        isSuccess.value = true;

        GTagHelper.sendEvent("form_submit", "landing_info_request", props.titleForm);
    } catch (error) {
        if (error.response && error.response.status === 400) {
            validationErrors.value = FormHelper.getValidationErrors(error.response.data);
        }
    }

    (<any>window).grecaptcha.reset();

    isLoadingForm.value = false;
}

function isValidationError(controlName: string): boolean {
    return FormHelper.isControlValidationError(controlName, validationErrors.value);
}
</script>